export const CREATE_EMAIL_POPUP_MODE_FIELD_NAME = 'mode'

export const CREATE_EMAIL_POPUP_MODE_STANDARD = 'standard'

export const CREATE_EMAIL_POPUP_MODE_ATTACHED_REQUESTS = 'related_requests'

export const CREATE_EMAIL_POPUP_MODE_OPTIONS = [
  {
    label: 'RequestProfile.EmailModeStandardKey',
    value: CREATE_EMAIL_POPUP_MODE_STANDARD,
  },
  {
    label: 'RequestProfile.EmailModeAttachedRequestsKey',
    value: CREATE_EMAIL_POPUP_MODE_ATTACHED_REQUESTS,
  },
]

export const QA_NAME_REQUEST_PROFILE_TAB_EMAILS_CREATE_EMAIL_MODE_FIELD =
  'requestProfileTabEmailsCreateEmailModeField'
